<div class="mydocma-dialog-container mydocma-mm-fault-duplicate-dialog-container mm-kb-scroll-footer" [class.mobile-view]="appContainerService.isMobileView">
  <div class="mydocma-dialog-header">
    <div class="mydocma-dialog-header-title">
      {{ 'MM.fault.duplicate.title' | translate }}
    </div>
    <div>
      <button mat-icon-button type="button" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="mydocma-dialog-body" [@.disabled]="isAnimationUnsupportedDevice" [class.anim-off]="isAnimationUnsupportedDevice">
    <mydocma-loader [size]="'small'" class="mydocma-mm-loader" *ngIf="isLoading"></mydocma-loader>

    <mydocma-mm-fault-duplicate-stepper
      [fault]="dialogData.fault"
      [project]="dialogData.project"
      #stepperComponent>
    </mydocma-mm-fault-duplicate-stepper>
  </div>

  <div class="mydocma-dialog-footer">
    <div style="margin-right: 10px">
      <button mat-stroked-button class="mydocma-btn" (click)="onCancel()" *ngIf="currentStepIndex < 1">
        {{ 'MM.general.button.cancel' | translate }}
      </button>
    </div>
    <div style="margin-right: 10px" *ngIf="currentStepIndex > 0">
      <button mat-stroked-button class="mydocma-btn" (click)="onPrevious()">
        {{ 'MM.general.button.back' | translate }}
      </button>
    </div>
    <div>
      <button mat-stroked-button class="mydocma-btn-primary"
              [disabled]="!canProceed() || isLoading"
              (click)="onNext()">
        {{ getNextButtonText() }}
      </button>
    </div>
  </div>
</div>
